<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("museum") }}</div>
    <div class="grid is-col-min-7">
      <div
        class="cell"
        @click="enter_hall(hall)"
        v-for="(hall, hidx) in halls"
        :key="hidx"
      >
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                v-if="hall.settings && hall.settings.image_url"
                :src="hall.settings.image_url"
              />
              <img
                v-else
                src="https://cdn-icons-png.freepik.com/512/11649/11649592.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ hall.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get, error_message } from "@/utils";

export default {
  name: "MuseumIndex",
  components: {},
  data() {
    return {
      halls: [],
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    enter_hall(hall) {
      let v = this;
      v.$router.push({
        path: `/museum/hall/${hall.uuid}`,
      });
    },
    refresh_halls() {
      let v = this;
      get("/museum/hall/all", {})
        .then((response) => {
          v.halls = response;
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  mounted() {
    let v = this;
    v.refresh_halls();
  },
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
